import { render, staticRenderFns } from "./GroupAddMember.vue?vue&type=template&id=0a637295&scoped=true&"
import script from "./GroupAddMember.vue?vue&type=script&lang=js&"
export * from "./GroupAddMember.vue?vue&type=script&lang=js&"
import style0 from "./GroupAddMember.vue?vue&type=style&index=0&id=0a637295&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a637295",
  null
  
)

export default component.exports